import React, { useContext, useEffect, useRef, useState } from 'react';
import Countdown from 'react-countdown';
import { Ralert } from './timerConfirm';
import { CartContext } from '../../../contexts/CartContext';
import { userAuth } from '../../../contexts/userContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
	CartCountdownTime,
	InactiveAlertTime,
	ExtendTime,
	FinalCheckoutTime,
} from './countdownEnums';

const InactivityTimer = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const {
		itemsCountstart,
		key,
		stage,
		setStage,
		alertTime,
		setAlertTime,
		extendCountdown,
		startCheckoutCountdown,
		clearCountdown,
		clearCart,
	} = useContext(CartContext);

	const { token, setToken } = useContext(userAuth);

	const [condialog, setCondialog] = useState(false);
	const [displayMinutes, setDisplayMinutes] = useState(0);
	const [displaySeconds, setDisplaySeconds] = useState(0);

	const isClearingRef = useRef(false);
	const hasClearedRef = useRef(false);

	const removecart = async () => {
		if (isClearingRef.current || hasClearedRef.current) {
			return;
		}

		isClearingRef.current = true;

		try {
			setCondialog(false);
			await clearCart();
			hasClearedRef.current = true;
			navigate('/services');
		} catch (error) {
			console.error('Error in removecart:', error);
		} finally {
			isClearingRef.current = false;
		}
	};

	const closemodel = () => {
		setCondialog(false);
		removecart();
	};

	const closeCheckoutAlert = () => {
		setCondialog(false);
	};

	const extendSession = () => {
		setCondialog(false);

		if (stage === 'extend') {
			extendCountdown();
		}
	};

	useEffect(() => {
		if (stage === 'extend') {
			setAlertTime(Date.now() + InactiveAlertTime.ALERT_WAIT * 60000);
			setCondialog(true);
		}
	}, [stage, setAlertTime]);

	useEffect(() => {
		hasClearedRef.current = false;
		isClearingRef.current = false;
	}, [stage]);

	const countdownRenderer = ({ minutes, seconds, completed }) => {
		if (completed) {
			return null;
		} else {
			setDisplayMinutes(minutes);
			setDisplaySeconds(seconds);
			return null;
		}
	};

	const finalCheckoutRenderer = ({ minutes, seconds, completed }) => {
		if (completed) {
			if (!isClearingRef.current && !hasClearedRef.current) {
				removecart();
			}
			return null;
		} else {
			setDisplayMinutes(minutes);
			setDisplaySeconds(seconds);
			return null;
		}
	};

	return (
		<>
			<Ralert
				msgtypeloadalert={t('Session Timeout Warning')}
				loadalert={condialog}
				closemodel={stage === 'checkout' ? closeCheckoutAlert : closemodel}
				confirmbt={extendSession}
				minutes={displayMinutes}
				seconds={displaySeconds}
				stage={stage}
			/>

			{stage === 'initial' && itemsCountstart && (
				<Countdown
					key={`initial-${key}`}
					date={itemsCountstart}
					renderer={countdownRenderer}
					onComplete={() => {
						setStage('extend');
					}}
				/>
			)}

			{stage === 'extend' && alertTime && (
				<Countdown
					key={`extend-${key}`}
					date={alertTime}
					renderer={countdownRenderer}
					onComplete={() => {
						removecart();
					}}
				/>
			)}

			{stage === 'final' && itemsCountstart && (
				<Countdown
					key={`final-${key}`}
					date={itemsCountstart}
					renderer={countdownRenderer}
					onComplete={() => {
						startCheckoutCountdown();
						setCondialog(true);
					}}
				/>
			)}

			{stage === 'checkout' && itemsCountstart && (
				<Countdown
					key={`checkout-${key}`}
					date={itemsCountstart}
					renderer={finalCheckoutRenderer}
					onComplete={() => {}}
				/>
			)}
		</>
	);
};

export default InactivityTimer;
